import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container-xxl bg-white p-0" }
const _hoisted_2 = { class: "container-fluid header bg-white p-0" }
const _hoisted_3 = { class: "row g-0 align-items-center flex-column-reverse flex-sm-row" }
const _hoisted_4 = { class: "col-sm-6 p-5 mt-lg-5" }
const _hoisted_5 = { class: "col-sm-6 animated fadeIn" }
const _hoisted_6 = { class: "position-relative" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = {
  key: 0,
  class: "position-absolute bottom-0 end-0 m-3"
}
const _hoisted_9 = { class: "card-body p-2 text-end" }
const _hoisted_10 = { class: "card-title mb-1 text-truncate" }
const _hoisted_11 = { class: "card-text mb-0 small text-primary" }
const _hoisted_12 = {
  key: 1,
  class: "text-center"
}
const _hoisted_13 = { class: "container-xxl py-5" }
const _hoisted_14 = { class: "container" }
const _hoisted_15 = { class: "row g-0 gx-5 align-items-end" }
const _hoisted_16 = {
  class: "col-lg-6 text-start text-lg-end wow slideInRight",
  "data-wow-delay": "0.1s"
}
const _hoisted_17 = { class: "nav nav-pills d-inline-flex justify-content-end mb-5" }
const _hoisted_18 = { class: "nav-item me-2" }
const _hoisted_19 = { class: "nav-item me-2" }
const _hoisted_20 = { class: "nav-item me-0" }
const _hoisted_21 = { class: "tab-content" }
const _hoisted_22 = {
  key: 0,
  class: "row g-4"
}
const _hoisted_23 = ["data-wow-delay"]
const _hoisted_24 = {
  key: 0,
  class: "col-12 text-center wow fadeInUp",
  "data-wow-delay": "0.1s"
}
const _hoisted_25 = {
  key: 1,
  class: "col-12 text-center"
}
const _hoisted_26 = {
  key: 1,
  class: "text-center"
}
const _hoisted_27 = { class: "container-xxl py-5" }
const _hoisted_28 = { class: "container" }
const _hoisted_29 = { class: "row g-5 align-items-center" }
const _hoisted_30 = {
  class: "col-lg-6 wow fadeIn",
  "data-wow-delay": "0.5s"
}
const _hoisted_31 = { class: "container-xxl py-5" }
const _hoisted_32 = { class: "container" }
const _hoisted_33 = { class: "bg-light rounded p-3" }
const _hoisted_34 = {
  class: "bg-white rounded p-4",
  style: {"border":"1px dashed rgba(0, 185, 142, 0.3)"}
}
const _hoisted_35 = { class: "row g-5 align-items-center" }
const _hoisted_36 = {
  class: "col-lg-6 wow fadeIn",
  "data-wow-delay": "0.5s"
}
const _hoisted_37 = { class: "container-xxl py-5" }
const _hoisted_38 = { class: "container" }
const _hoisted_39 = {
  key: 0,
  class: "row g-4"
}
const _hoisted_40 = ["data-wow-delay"]
const _hoisted_41 = { class: "rounded p-4" }
const _hoisted_42 = { class: "icon mb-3" }
const _hoisted_43 = ["src", "alt"]
const _hoisted_44 = {
  key: 1,
  class: "text-center"
}
const _hoisted_45 = { class: "container-xxl py-5" }
const _hoisted_46 = { class: "container" }
const _hoisted_47 = {
  key: 0,
  class: "row g-4"
}
const _hoisted_48 = ["data-wow-delay"]
const _hoisted_49 = { class: "team-item rounded overflow-hidden" }
const _hoisted_50 = { class: "position-relative" }
const _hoisted_51 = ["src", "alt"]
const _hoisted_52 = { class: "position-absolute start-50 top-100 translate-middle d-flex align-items-center" }
const _hoisted_53 = ["href"]
const _hoisted_54 = ["href"]
const _hoisted_55 = ["href"]
const _hoisted_56 = { class: "text-center p-4 mt-3" }
const _hoisted_57 = { class: "fw-bold mb-0" }
const _hoisted_58 = {
  key: 1,
  class: "text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_SearchFilter = _resolveComponent("SearchFilter")!
  const _component_PropertyCard = _resolveComponent("PropertyCard")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Navbar),
    _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
    _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1)),
    _cache[29] || (_cache[29] = _createElementVNode("br", null, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("h4", { class: "display-5 animated fadeIn mb-4" }, [
            _createTextVNode(" Find A "),
            _createElementVNode("span", { class: "text-primary" }, "Perfect Property"),
            _createTextVNode(" For You and Your Family ")
          ], -1)),
          _cache[5] || (_cache[5] = _createElementVNode("p", { class: "animated fadeIn mb-4 pb-2" }, " Discover a wide selection of properties tailored to your lifestyle and budget. Whether you're buying or renting, we help you find a safe, comfortable space where lasting memories are made — from homes and apartments to land and commercial spaces. ", -1)),
          _createVNode(_component_router_link, {
            class: "btn btn-primary py-3 px-5 me-3 animated fadeIn",
            to: "/properties"
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode(" Get Started ", -1)
            ])),
            _: 1,
            __: [3]
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.carouselImages.length && !_ctx.carouselLoading)
            ? (_openBlock(), _createBlock(_component_swiper, {
                key: 0,
                modules: _ctx.modules,
                "slides-per-view": 1,
                "space-between": 0,
                autoplay: { delay: 4000, disableOnInteraction: false },
                pagination: { clickable: true },
                class: "header-carousel"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carouselImages, (image, index) => {
                    return (_openBlock(), _createBlock(_component_swiper_slide, { key: index }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("img", {
                            class: "img-fluid",
                            src: image.src,
                            alt: image.alt
                          }, null, 8, _hoisted_7),
                          (image.id)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createVNode(_component_router_link, {
                                  to: '/property-details',
                                  onClick: ($event: any) => (_ctx.storePropertyId(image.id)),
                                  class: "card bg-white bg-opacity-75 border-0 shadow-sm p-2 text-decoration-none",
                                  style: {"max-width":"250px"}
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_9, [
                                      _createElementVNode("h6", _hoisted_10, _toDisplayString(image.title), 1),
                                      _createElementVNode("p", _hoisted_11, _toDisplayString(image.status), 1)
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modules"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, _cache[6] || (_cache[6] = [
                _createElementVNode("div", {
                  class: "spinner-border text-primary",
                  role: "status"
                }, [
                  _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                ], -1)
              ])))
        ])
      ])
    ]),
    _createVNode(_component_SearchFilter),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "col-lg-6" }, [
            _createElementVNode("div", {
              class: "text-start mx-auto mb-5 wow slideInLeft",
              "data-wow-delay": "0.1s"
            }, [
              _createElementVNode("h1", { class: "mb-3" }, "Property Listing"),
              _createElementVNode("p", null, " Browse through our latest properties available for sale and rent across Rwanda. ")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("ul", _hoisted_17, [
              _createElementVNode("li", _hoisted_18, [
                _createElementVNode("a", {
                  class: _normalizeClass(["btn btn-outline-primary", { active: _ctx.activeTab === 'featured' }]),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.activeTab = 'featured'; _ctx.fetchProperties()})
                }, "Featured", 2)
              ]),
              _createElementVNode("li", _hoisted_19, [
                _createElementVNode("a", {
                  class: _normalizeClass(["btn btn-outline-primary", { active: _ctx.activeTab === 'for-sale' }]),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.activeTab = 'for-sale'; _ctx.fetchProperties('for_sale')})
                }, "For Sale", 2)
              ]),
              _createElementVNode("li", _hoisted_20, [
                _createElementVNode("a", {
                  class: _normalizeClass(["btn btn-outline-primary", { active: _ctx.activeTab === 'for-rent' }]),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.activeTab = 'for-rent'; _ctx.fetchProperties('for_rent')})
                }, "For Rent", 2)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['featured', 'for-sale', 'for-rent'], (tab) => {
            return _createElementVNode("div", {
              class: _normalizeClass(["tab-pane fade", { 'show active': _ctx.activeTab === tab }]),
              key: tab
            }, [
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.properties, (property, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: property.id,
                        class: "col-lg-4 col-sm-6 wow fadeInUp",
                        "data-wow-delay": `${0.1 + index * 0.2}s`
                      }, [
                        _createVNode(_component_PropertyCard, {
                          property: property,
                          delay: 0.1 + index * 0.2
                        }, null, 8, ["property", "delay"])
                      ], 8, _hoisted_23))
                    }), 128)),
                    (_ctx.properties.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _createVNode(_component_router_link, {
                            class: "btn btn-primary py-3 px-5",
                            to: "/properties"
                          }, {
                            default: _withCtx(() => _cache[8] || (_cache[8] = [
                              _createTextVNode(" Browse More Property ", -1)
                            ])),
                            _: 1,
                            __: [8]
                          })
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_25, _cache[9] || (_cache[9] = [
                          _createElementVNode("p", null, "No properties found.", -1)
                        ])))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_26, _cache[10] || (_cache[10] = [
                    _createElementVNode("div", {
                      class: "spinner-border text-primary",
                      role: "status"
                    }, [
                      _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                    ], -1)
                  ])))
            ], 2)
          }), 64))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _cache[15] || (_cache[15] = _createElementVNode("div", {
            class: "col-lg-6 wow fadeIn",
            "data-wow-delay": "0.1s"
          }, [
            _createElementVNode("div", { class: "about-img position-relative overflow-hidden p-5 pe-0" }, [
              _createElementVNode("img", {
                class: "img-fluid w-100",
                src: "/img/estate-rwanda.png",
                alt: "About Estate Rwanda"
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_30, [
            _cache[13] || (_cache[13] = _createElementVNode("h1", { class: "mb-4" }, "Rwanda’s Gateway to Trusted Real Estate", -1)),
            _cache[14] || (_cache[14] = _createElementVNode("p", { class: "mb-4" }, " Estate Rwanda is your go-to platform for buying, selling, and renting properties across the country. We connect home seekers, investors, and property owners through a seamless and transparent digital experience. Whether you're looking for a family home in Kigali or commercial land in secondary cities, we are here to guide you every step of the way. ", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.aboutFeatures, (feature) => {
              return (_openBlock(), _createElementBlock("p", { key: feature }, [
                _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fa fa-check text-primary me-3" }, null, -1)),
                _createTextVNode(_toDisplayString(feature), 1)
              ]))
            }), 128)),
            _createVNode(_component_router_link, {
              class: "btn btn-primary py-3 px-5 mt-3",
              to: "/about"
            }, {
              default: _withCtx(() => _cache[12] || (_cache[12] = [
                _createTextVNode("Read More", -1)
              ])),
              _: 1,
              __: [12]
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_31, [
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _cache[19] || (_cache[19] = _createElementVNode("div", {
                class: "col-lg-6 wow fadeIn",
                "data-wow-delay": "0.1s"
              }, [
                _createElementVNode("img", {
                  class: "img-fluid rounded w-100",
                  src: "/img/real-estate.png",
                  alt: "Call to Action"
                })
              ], -1)),
              _createElementVNode("div", _hoisted_36, [
                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "mb-4" }, [
                  _createElementVNode("h1", { class: "mb-3" }, "Contact Our Certified Agent Today"),
                  _createElementVNode("p", null, " Ready to find your next home or investment property? Our experienced and certified agents are here to guide you every step of the way. Whether you have questions or want to book a property visit, we're just one call or click away. ")
                ], -1)),
                _createVNode(_component_router_link, {
                  class: "btn btn-primary py-3 px-4 me-2",
                  to: "/contact"
                }, {
                  default: _withCtx(() => _cache[16] || (_cache[16] = [
                    _createElementVNode("i", { class: "fa fa-phone-alt me-2" }, null, -1),
                    _createTextVNode("Make A Call ", -1)
                  ])),
                  _: 1,
                  __: [16]
                }),
                _createVNode(_component_router_link, {
                  class: "btn btn-dark py-3 px-4",
                  to: "/appointment"
                }, {
                  default: _withCtx(() => _cache[17] || (_cache[17] = [
                    _createElementVNode("i", { class: "fa fa-calendar-alt me-2" }, null, -1),
                    _createTextVNode("Get Appointment ", -1)
                  ])),
                  _: 1,
                  __: [17]
                })
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("div", _hoisted_38, [
        _cache[21] || (_cache[21] = _createElementVNode("div", {
          class: "text-center mx-auto mb-5 wow fadeInUp",
          "data-wow-delay": "0.1s",
          style: {"max-width":"600px"}
        }, [
          _createElementVNode("h1", { class: "mb-3" }, "Explore Property Types"),
          _createElementVNode("p", null, " Discover a wide range of property categories tailored to meet your needs. Estate Rwanda helps you find the perfect space, whether you're buying, renting, or investing across Rwanda. ")
        ], -1)),
        (!_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: category.name,
                  class: "col-lg-3 col-sm-6 wow fadeInUp",
                  "data-wow-delay": `${0.1 + index * 0.2}s`
                }, [
                  _createVNode(_component_router_link, {
                    class: "cat-item d-block bg-light text-center rounded p-3",
                    to: "/properties"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("img", {
                            class: "img-fluid",
                            src: category.icon,
                            alt: category.name
                          }, null, 8, _hoisted_43)
                        ]),
                        _createElementVNode("h6", null, _toDisplayString(category.name), 1),
                        _createElementVNode("span", null, _toDisplayString(category.count) + " Properties", 1)
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ], 8, _hoisted_40))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_44, _cache[20] || (_cache[20] = [
              _createElementVNode("div", {
                class: "spinner-border text-primary",
                role: "status"
              }, [
                _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
              ], -1)
            ])))
      ])
    ]),
    _createElementVNode("div", _hoisted_45, [
      _createElementVNode("div", _hoisted_46, [
        _cache[26] || (_cache[26] = _createElementVNode("div", {
          class: "text-center mx-auto mb-5 wow fadeInUp",
          "data-wow-delay": "0.1s",
          style: {"max-width":"600px"}
        }, [
          _createElementVNode("h1", { class: "mb-3" }, "Our Agents"),
          _createElementVNode("p", null, " Our agents offer personalized guidance, reliable support, and expert advice—making your buying, renting, or selling journey seamless and stress-free. ")
        ], -1)),
        (!_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agents, (agent, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: agent.id,
                  class: "col-lg-3 col-sm-6 wow fadeInUp",
                  "data-wow-delay": `${0.1 + index * 0.2}s`
                }, [
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("img", {
                        class: "img-fluid",
                        src: agent.image,
                        alt: agent.name
                      }, null, 8, _hoisted_51),
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("a", {
                          class: "btn btn-square mx-1",
                          href: agent.social.facebook
                        }, _cache[22] || (_cache[22] = [
                          _createElementVNode("i", { class: "fab fa-facebook-f" }, null, -1)
                        ]), 8, _hoisted_53),
                        _createElementVNode("a", {
                          class: "btn btn-square mx-1",
                          href: agent.social.twitter
                        }, _cache[23] || (_cache[23] = [
                          _createElementVNode("i", { class: "fab fa-twitter" }, null, -1)
                        ]), 8, _hoisted_54),
                        _createElementVNode("a", {
                          class: "btn btn-square mx-1",
                          href: agent.social.instagram
                        }, _cache[24] || (_cache[24] = [
                          _createElementVNode("i", { class: "fab fa-instagram" }, null, -1)
                        ]), 8, _hoisted_55)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("h5", _hoisted_57, _toDisplayString(agent.name), 1),
                      _createElementVNode("small", null, _toDisplayString(agent.designation), 1)
                    ])
                  ])
                ], 8, _hoisted_48))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_58, _cache[25] || (_cache[25] = [
              _createElementVNode("div", {
                class: "spinner-border text-primary",
                role: "status"
              }, [
                _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
              ], -1)
            ])))
      ])
    ]),
    _createVNode(_component_Footer),
    _cache[30] || (_cache[30] = _createElementVNode("a", {
      href: "#",
      class: "btn btn-lg btn-primary btn-lg-square rounded-circle back-to-top"
    }, [
      _createElementVNode("i", { class: "bi bi-arrow-up" })
    ], -1))
  ]))
}